/**
 * DatabaseRepository - PocketBase CRUD for boardgames collection
 */

import PocketBase from 'pocketbase';

export class DatabaseRepository {
    constructor(pocketbaseURL, proxy) {
        this.pb = new PocketBase(pocketbaseURL);
        this.proxy = proxy;
        this.collectionName = 'boardgames';
    }

    async getAllBoardgames() {
        try {
            return await this.pb.collection(this.collectionName).getFullList({
                $autoCancel: false,
                batch: 1000,
            });
        } catch (error) {
            if (error.message?.includes('autocancelled')) return [];
            throw error;
        }
    }

    async getBoardgame(id) {
        return this.pb.collection(this.collectionName).getOne(id);
    }

    async findByBggId(bggId) {
        try {
            return await this.pb.collection(this.collectionName)
                .getFirstListItem(`bggId="${bggId}"`, { $autoCancel: false });
        } catch (error) {
            if (error.status === 404) return null;
            throw error;
        }
    }

    async downloadImage(url, filename) {
        try {
            const response = await fetch(url);
            if (!response.ok) return null;
            const blob = await response.blob();
            return new File([blob], filename, { type: blob.type });
        } catch {
            return null;
        }
    }

    async createBoardgame(data) {
        const formData = new FormData();

        Object.entries(data).forEach(([key, value]) => {
            if (value === undefined || value === null) return;
            if (Array.isArray(value)) {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        });

        // Download and attach thumbnail image
        if (data.imageURL) {
            const imageFile = await this.downloadImage(data.imageURL, `thumb_${data.bggId}.jpg`);
            if (imageFile) formData.append('thumbImage', imageFile);
        }

        return this.proxy.collection(this.collectionName).create(formData);
    }

    async updateBoardgame(id, data) {
        return this.proxy.collection(this.collectionName).update(id, data);
    }

    async deleteBoardgame(id) {
        await this.proxy.collection(this.collectionName).delete(id);
        return true;
    }
}

export default DatabaseRepository;
